module.exports = __webpack_public_path__ + "static/media/behance.5d6cf36e.svg";